import { render, staticRenderFns } from "./IndicatoriView.vue?vue&type=template&id=2ea434fc"
import script from "./IndicatoriView.vue?vue&type=script&lang=js"
export * from "./IndicatoriView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports